import Chart from 'chart.js/auto';
import pattern from 'patternomaly';

function getCSSCustomProperty(prop) {
  return getComputedStyle(document.documentElement).getPropertyValue(prop).trim();
}

const centerTextPlugin = {
  id: 'centerText',
  beforeDraw(chart) {
    const { ctx, chartArea } = chart;
    if (!chartArea || !chart.getDatasetMeta(0).data.length) return;

    const canvas = chart.canvas;
    const line1 = canvas.dataset.centerLine1 || '';
    const line2 = canvas.dataset.centerLine2 || '';

    const arc = chart.getDatasetMeta(0).data[0];
    const donutRadius = (arc.outerRadius + arc.innerRadius) / 2;

    const line1Size = donutRadius / 14;
    const line2Size = donutRadius / 9;

    const centerX = (chartArea.left + chartArea.right) / 2;
    let centerY = (chartArea.top + chartArea.bottom) / 2;

    if (chart.width < 600) {
      const offset = line1Size + line2Size + 10;
      centerY = chartArea.top + offset;
    }

    ctx.save();
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    ctx.font = `400 ${line1Size}px ${getCSSCustomProperty('--font-family')}`;
    ctx.fillText(line1, centerX, centerY - line1Size / 0.8);

    ctx.font = `700 ${line2Size}px ${getCSSCustomProperty('--font-family')}`;
    ctx.fillText(line2, centerX, centerY + line2Size / 3);

    ctx.restore();
  }
};

const insideValuePlugin = {
  id: 'insideValue',
  afterDatasetDraw(chart) {
    const { ctx, data, chartArea } = chart;
    if (!chartArea) return;

    const meta = chart.getDatasetMeta(0);
    const baseSize = document.documentElement.clientWidth < 600 ? 14 : 20;

    ctx.save();
    ctx.font = `700 ${baseSize}px Poppins, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineWidth = baseSize * 0.2;
    ctx.strokeStyle = 'white';

    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;

    meta.data.forEach((arc, index) => {
      const angle = (arc.startAngle + arc.endAngle) / 2;
      const inner = arc.innerRadius;
      const outer = arc.outerRadius;
      const midRadius = inner + (outer - inner) / 2;

      const x = centerX + Math.cos(angle) * midRadius;
      const y = centerY + Math.sin(angle) * midRadius;
      const value = data.datasets[0].data[index] + '%';

      ctx.strokeText(value, x, y);
      ctx.fillStyle = 'black';
      ctx.fillText(value, x, y);
    });

    ctx.restore();
  }
};

function initDonuts() {
  document.querySelectorAll('.donut-chart').forEach(canvas => {
    if (canvas.chart) canvas.chart.destroy();

    const ctx = canvas.getContext('2d');
    const parent = canvas.parentElement;
    const canvasWidth = parent.clientWidth;

    canvas.style.width = canvasWidth + 'px';
    canvas.style.height = canvasWidth + 'px';
    canvas.width = canvasWidth;
    canvas.height = canvasWidth;

    const chartLabels = (canvas.dataset.labels || '').split(', ');
    const chartData = (canvas.dataset.values || '').split(',').map(Number);
    const isMobile = document.documentElement.clientWidth < 600;

    const maxRadius = 470 / 2;

    canvas.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: chartLabels,
        datasets: [{
          label: 'Répartition',
          data: chartData,
          backgroundColor: [
            '#3E2881',
            '#E32257',
            '#FFF1F5',
            pattern.draw('zigzag', '#E32257'),
            pattern.draw('diagonal', '#3F2985'),
            pattern.draw('dot', '#E32257')
          ].slice(0, chartData.length),
          borderColor: 'black',
          borderWidth: 2,
          cutout: document.documentElement.clientWidth < 600 ? 0 : '65%',
          radius: (ctx) => {
            const chartArea = ctx.chart.chartArea;
            if (!chartArea) return maxRadius;
            const availableRadius = Math.min(chartArea.width, chartArea.height) / 2;
            return Math.min(availableRadius, maxRadius);
          },
          innerRadius: (ctx) => {
            const outer = ctx.dataset.radius(ctx);
            return outer * 0.65;
          }
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: 0 },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'black',
              font: {
                family: getCSSCustomProperty('--font-family'),
                size: Math.min(canvasWidth / (isMobile ? 20 : 25), 16),
                weight: '400',
              },
              padding: isMobile ? 20 : 50,
              usePointStyle: true,
              pointStyle: 'circle',
              verticalAlign: 'bottom',
              boxHeight: 16,
            }
          },
          tooltip: { enabled: false }
        },
        hover: { mode: null },
        interaction: { mode: null, intersect: false, events: [] }
      },
      plugins: [centerTextPlugin, insideValuePlugin]
    });
  });
}

window.addEventListener('load', initDonuts);
window.addEventListener('resize', debounce(initDonuts, 100));

function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
